import React from 'react'

import { Layout } from 'components'

import { UpdateUser } from 'modules/Users/containers'

const UpdateUserPage = () => (
  <Layout>
    <UpdateUser />
  </Layout>
)

export default UpdateUserPage
